



















  import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
import { WexDebitCardDeactivationReasons, WexDebitCardManageCardViewState } from "@/shared/types";

  @Component({
    components: {
    }
  })
export default class WexDebitCardDeactivateCardForm extends Vue {
  wexDebitCardsStore = useWexDebitCardsStore();

    selected = null;

    WexDebitCardDeactivationReasons = WexDebitCardDeactivationReasons;
    WexDebitCardManageCardViewState = WexDebitCardManageCardViewState;

    get reasons () {
      return WexDebitCardDeactivationReasons;
    }

    get submitDisabled () {
    return this.selected === null;
  }

    onSubmitChanges (e: Event) {
      e.preventDefault();
      this.wexDebitCardsStore.setWexDebitCardManageCardViewState(WexDebitCardManageCardViewState.ConfirmAddressForm);
    }
}
